import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    selectAllUglImportTask, selectUglImportTaskEntities,
    selectUglImportTaskFetched, selectUglImportTaskLatestUpdatedAt,
    UGL_IMPORT_TASK_KEY,
    UglImportTaskState,
} from '../reducers/ugl-import-task.reducer';
import { selectMaterialListEntities } from '../reducers/material-list.reducer';



const selectState = createFeatureSelector<UglImportTaskState>(UGL_IMPORT_TASK_KEY);

export const getUglImportTaskDictionary = createSelector(selectState, selectUglImportTaskEntities);
export const getUglImportTasks = createSelector(selectState, selectAllUglImportTask);
export const getUglImportTasksFetched = createSelector(selectState, selectUglImportTaskFetched);
export const getUglImportTaskLatestUpdatedAt = createSelector(selectState, selectUglImportTaskLatestUpdatedAt);

//export const getUglImportTaskById = (props: { id: number }) => createSelector(getUglImportTaskDictionary, (dictionary) => props?.id && dictionary[props.id]);
